import React, { useEffect, useState } from "react"
import { Descriptions, Typography, Spin } from "antd"

const { Title, Text } = Typography

export default function LastMonths({ invoices, selectedManager }) {
  const [monthsData, setMonthsData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    const monthsArray = []
    const currentDate = new Date()
    // Generate data for the past 12 months relative to the current date.
    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1)
      const month = date.getMonth() // 0-indexed
      const year = date.getFullYear()
      const monthLabel = date.toLocaleString("default", { month: "short" })

      // Filter invoices for the selected manager (if provided) and matching month/year.
      const monthInvoices = invoices.filter((invoice) => {
        if (selectedManager && selectedManager !== "allUsers") {
          if (invoice.userId !== selectedManager) return false
        }
        const invoiceDate = new Date(invoice.invoiceDate.seconds * 1000)
        return invoiceDate.getFullYear() === year && invoiceDate.getMonth() === month
      })

      // Sum revenue for this month.
      const revenue = monthInvoices.reduce(
        (sum, invoice) => sum + (invoice.totalData?.totalNetoSum || 0),
        0
      )

      monthsArray.push({ label: `${monthLabel} ${year}`, revenue, month, year })
    }

    // Sort in descending order (latest month first).
    monthsArray.sort((a, b) => {
      if (a.year === b.year) {
        return b.month - a.month
      }
      return b.year - a.year
    })

    setMonthsData(monthsArray)
    setLoading(false)
  }, [invoices, selectedManager])

  return (
    <div style={{ padding: 25, background: "white", borderRadius: 15 }}>
      <Title level={4}>Last 12 Months Data</Title>
      {loading ? (
        <Spin />
      ) : (
        <Descriptions column={1} bordered size="small" style={{ marginTop: 20 }}>
          {monthsData.map((item, index) => (
            <Descriptions.Item label={item.label} key={index}>
              <Text style={{ color: "#237804" }}>
                €
                {Number(item.revenue).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </Descriptions.Item>
          ))}
        </Descriptions>
      )}
    </div>
  )
}
